import React from 'react';
import { useField } from 'formik';
import {
  FormikAutoAddress,
  FormikDatePicker,
  FormikField,
} from '@components/formik';
import {
  Grid,
  IconButton,
  InputAdornment,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const PersonalDetails: React.FC = () => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [meta] = useField('home');

  const theme = useTheme();
  const medium = useMediaQuery(theme.breakpoints.up('sm'));
  const space = medium ? 2 : 0;
  return (
    <>
      <Typography variant="h4" component="h2" gutterBottom>
        Verify your personal details
      </Typography>
      <Typography variant="body1" gutterBottom color="text.secondary">
        {import.meta.env.VITE_SITE} collects this information to verify your
        identity and keep your account safe.
      </Typography>

      <Grid container spacing={space}>
        <Grid item xs={12} sm={6}>
          <FormikField name="fName" label="First name" placeholder="John" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormikField name="lName" label="Last name" placeholder="Doe" />
        </Grid>
      </Grid>

      <FormikField
        name="email"
        label="Email address"
        placeholder="example@email.com"
        type="email"
      />

      <FormikDatePicker
        name="birthday"
        fullWidth={false}
        label="Date of birth"
      />

      <FormikAutoAddress
        label="Home address"
        region={meta.value.toLowerCase()}
      />

      {/* <FormikCountry name="home" label="Home address" maxHeight={220} />

      <FormikField name="address" placeholder="Address line 1" />

      <FormikField name="address2" placeholder="Address line 2" />

      <FormikField name="city" placeholder="City" />

      <FormikField name="province" select>
        <MenuItem value="ontario">Ontario</MenuItem>
        <MenuItem value="quebec">Quebec</MenuItem>
        <MenuItem value="nova scotia">Nova Scotia</MenuItem>
      </FormikField>

      <FormikField name="postal" placeholder="Postal code" /> */}

      {/* <Typography variant="body2" color="text.secondary" mt={1}>
        We use this information to verify your identity. If you leave this field
        blank, we'll email you instructions to submit another form of ID.
      </Typography> */}
    </>
  );
};

export default PersonalDetails;
